import {Injectable} from '@angular/core';

import {AirComponentType} from '../../../../shared';
import {Subject} from 'rxjs';
import {TriggerEvent} from '../../../../afb-api/models/trigger-event';
import {Airnote} from '../../../../afb-api/models/airnote';

@Injectable()
export class MultiGraphService {
  // Global events
  private hoverAnnounced = new Subject<Date>();
  private outAnnounced = new Subject<void>();
  private clickAnnounced = new Subject<{ isPinned: boolean, source: string }>();
  // Indicator events
  private indicatorDotHoverAnnounced = new Subject<{ hoveredIndex: number, deviceIndex: number }>();
  private indicatorDotOutAnnounced = new Subject<void>();
  private pinTooltipAnnounced = new Subject<{
    hoveredIndex: number,
    sourceType: string,
    deviceIndex: number,
    isInvokedFromNoti: boolean }>();
  private unpinTooltipAnnounced = new Subject<void>();
  // Trigger event events
  private pinTeAnnounced = new Subject<{ triggerEvent: TriggerEvent, sourceType: string, deviceIndex: number }>();
  private removeTeAnnounced = new Subject<void>();
  // Notification pin state events
  private pinnedNotiAnnounced = new Subject<any>();
  private unpinnedNotiAnnounced = new Subject<void>();

  // Global observables
  hoverAnnounced$ = this.hoverAnnounced.asObservable();
  outAnnounced$ = this.outAnnounced.asObservable();
  clickAnnounced$ = this.clickAnnounced.asObservable();
  // Indicator observables
  indicatorDotHoverAnnounced$ = this.indicatorDotHoverAnnounced.asObservable();
  indicatorDotOutAnnounced$ = this.indicatorDotOutAnnounced.asObservable();
  pinTooltipAnnounced$ = this.pinTooltipAnnounced.asObservable();
  unpinTooltipAnnounced$ = this.unpinTooltipAnnounced.asObservable();
  // Trigger event observables
  pinTeAnnounced$ = this.pinTeAnnounced.asObservable();
  removeTeAnnounced$ = this.removeTeAnnounced.asObservable();
  // Notification pin state observables
  pinnedNotiAnnounced$ = this.pinnedNotiAnnounced.asObservable();
  unpinnedNotiAnnounced$ = this.unpinnedNotiAnnounced.asObservable();

  source: string = '';
  isPinned: boolean = false;
  isTooltipPinned: boolean = false;

  backdropCtr: number = 0;
  isBackdrop: boolean = false;

  constructor() { }

  // Global announce
  announceHover(xDate: Date): void {
    this.hoverAnnounced.next(xDate);
  }
  announceOut(): void {
    this.outAnnounced.next();
  }
  announceClick(isPinned: boolean, source: AirComponentType): void {
    this.isPinned = isPinned;
    this.source = source;
    this.clickAnnounced.next({ 'isPinned': isPinned, 'source': source });
  }
  // Indicator announce
  announceIndicatorDotHover(hoveredIndex: number, deviceIndex: number): void {
    this.indicatorDotHoverAnnounced.next({ 'hoveredIndex': hoveredIndex, 'deviceIndex': deviceIndex });
  }
  announceIndicatorDotOut(): void {
    this.indicatorDotOutAnnounced.next();
  }
  announcePinTooltip(hoveredIndex: number, sourceType: AirComponentType, deviceIndex: number, isInvokedFromNoti: boolean): void {
    this.pinTooltipAnnounced.next(
      { hoveredIndex, sourceType, deviceIndex, isInvokedFromNoti }
    );
  }
  announceUnpinTooltip(): void {
    this.unpinTooltipAnnounced.next();
  }
  // Trigger Event announce
  announcePinTe(triggerEvent: TriggerEvent, sourceType: AirComponentType, deviceIndex: number): void {
    this.pinTeAnnounced.next({ 'triggerEvent': triggerEvent, 'sourceType': sourceType, 'deviceIndex': deviceIndex });
  }
  announceRemoveTe(): void {
    this.removeTeAnnounced.next();
  }
  // Notification pin status announce for sync between noti and timeline pane
  announcePinnedNoti(notification: Airnote | TriggerEvent): void {
    this.pinnedNotiAnnounced.next(notification);
  }
  announceUnpinnedNoti(): void {
    this.unpinnedNotiAnnounced.next();
  }
}
